import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";

import { Container, Header, Grid, Button, Form, DropdownProps, Segment, Label, Statistic, Icon, Checkbox } from "semantic-ui-react";

import AliancaMenu from "../../components/Menu";
import Footer from "../../components/Footer";

import TableApp, { ITableAppRender } from "../../components/TableApp";

import errors from "../../Utils/ExtractErrors";
import AgentOpenedRepository, { IAgentOpened, IAgentOpenedParams } from "../../Repositories/AgentOpenedRepository";
import RegionalManagerRepository, { IRegionalManagerListModel } from "../../Repositories/RegionalManagerRepository";
import SectorManagerRepository, { ISectorManagerListModel } from "../../Repositories/SectorManagerRepository";
import AgentsRepository, { IAgentListModel } from "../../Repositories/AgentsRepository";
import CustomLoader from "../../components/CustomLoader";
import { format } from "date-fns";
import { CSVLink } from "react-csv";

const AgentOpened: React.FC = () => {

    const date = new Date();
    const [list, setList] = useState<IAgentOpened[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<IAgentOpenedParams>({ mensal: false, year: date.getFullYear().toString(), month: (date.getMonth() + 3).toString(), tipo: "", statusKit: "", liberacao: "", prorrogado: "", regionalId: "", sectorId: "", agentId: "" });
    const [regionalManagers, setRegionalManagers] = useState<IRegionalManagerListModel[]>([]);
    const [sectorManagers, setSectorManagers] = useState<ISectorManagerListModel[]>([]);
    const [agents, setAgents] = useState<IAgentListModel[]>([]);
    const total = list.reduce((a, b) => a + b.quantidade, 0);
    var totalNovo = 0;
    var totalAcerto = 0;

    list.forEach(tipoLista => {
        tipoLista.tipo === 0 ? totalNovo += tipoLista.quantidade : totalAcerto += tipoLista.quantidade
    });

    const optionsYear = [
        { key: "1", text: "2020", value: "2020" },
        { key: "2", text: "2021", value: "2021" },
        { key: "3", text: "2022", value: "2022" },
        { key: "4", text: "2023", value: "2023" },
        { key: "5", text: "2024", value: "2024" },
        { key: "6", text: "2025", value: "2025" },
        { key: "7", text: "2026", value: "2026" },
    ];

    const optionsMonth = [
        { key: "1", text: "JANEIRO", value: "1" },
        { key: "2", text: "FEVEREIRO", value: "2" },
        { key: "3", text: "MARÇO", value: "3" },
        { key: "4", text: "ABRIL", value: "4" },
        { key: "5", text: "MAIO", value: "5" },
        { key: "6", text: "JUNHO", value: "6" },
        { key: "7", text: "JULHO", value: "7" },
        { key: "8", text: "AGOSTO", value: "8" },
        { key: "9", text: "SETEMBRO", value: "9" },
        { key: "10", text: "OUTUBRO", value: "10" },
        { key: "11", text: "NOVEMBRO", value: "11" },
        { key: "12", text: "DEZEMBRO", value: "12" }
    ];

    const optionsType = [
        { key: "1", text: "AMBOS", value: "0,1" },
        { key: "2", text: "NOVO", value: "0" },
        { key: "3", text: "ACERTO", value: "1" }
    ];

    const optionsState = [
        { key: "1", text: "TODOS", value: "1,2,3,4" },
        { key: "2", text: "COM GERENTE DE SETOR", value: "1" },
        { key: "3", text: "COM REPRESENTANTE", value: "2" },
        { key: "4", text: "COM REVENDEDOR", value: "3" },
        { key: "5", text: "PRÉ-CONFERIDO", value: "4" }
    ];

    const optionsLiberation = [
        { key: "1", text: "TODOS", value: "0,1,2,3" },
        { key: "2", text: "NÃO CADASTRADOS", value: "0" },
        { key: "3", text: "AGUARDANDO LIBERAÇÃO", value: "1" },
        { key: "4", text: "NÃO LIBERADO", value: "3" },
        { key: "5", text: "LIBERADO", value: "2" }
    ];

    const optionsProrrogado = [
        { key: "1", text: "AMBOS", value: "0,1" },
        { key: "2", text: "SIM", value: "1" },
        { key: "3", text: "NÃO", value: "0" }
    ];

    const load = async () => {

        setLoading(true);
        try {
            const response = await AgentOpenedRepository.Opened({
                mensal: state.mensal,
                year: state.year,
                month: state.month,
                tipo: state.tipo,
                statusKit: state.statusKit,
                liberacao: state.liberacao,
                prorrogado: state.prorrogado,
                regionalId: state.regionalId,
                sectorId: state.sectorId,
                agentId: state.agentId
            });

            setList(response);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    };

    const LoadRegionalManagers = useCallback(async () => {
        const result = await RegionalManagerRepository.List({
            filter: "Status == 1"
        });

        setRegionalManagers(result.list);
    }, []);

    useEffect(() => { LoadRegionalManagers() }, [LoadRegionalManagers]);

    const LoadSectorManagers = useCallback(async (id: string) => {
        const result = await SectorManagerRepository.List({
            filter: `GerenteRegionalId == "${id}" && Status == 1`
        });

        setSectorManagers(result.list);
    }, []);

    const LoadAgents = useCallback(async (id: string) => {
        const result = await AgentsRepository.List({
            filter: `GerenteSetorId == "${id}" && Status == 1`
        });

        setAgents(result.list);
    }, []);


    const onRegionalManagerChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value, sectorId: "", agentId: "" }));
        LoadSectorManagers(value?.toString() || "");
    }

    const onSectorManagerChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value, agentId: "" }));
        LoadAgents(value?.toString() || "");
    }

    const onDropdownChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value }));
    }

    const setDisabled = () => {
        if (!state.year || !state.liberacao || !state.tipo || !state.statusKit || !state.prorrogado) {
            return true;
        }
    }

    const setTipo = (tipo: number) => {
        return tipo === 0 ? <Label color="pink" align="center" content="Novo" /> : <Label color="purple" align="center" content="Acerto" />;
    }
    const onChangeMensal = () => {
        setState(state => ({ ...state, mensal: !state.mensal }));
    }

    const tableRender: ITableAppRender[] = [
        {
            header: "Gerente de Setor",
            content: (x: IAgentOpened) => x.gerenteSetor,
            textAlign: "left",
            width: 5
        },
        {
            header: "Representante",
            content: (x: IAgentOpened) => x.representante,
            textAlign: "left",
            width: 5
        },
        {
            header: "Acerto",
            content: (x: IAgentOpened) => format(new Date(x.acerto), "dd/MM/yyyy"),
            textAlign: "left",
            width: 3
        },
        {
            header: "Qtd",
            content: (x: IAgentOpened) => x.quantidade,
            textAlign: "center",
            width: 1
        },
        {
            header: "Tipo",
            content: (x: IAgentOpened) => setTipo(x.tipo),
            textAlign: "center",
            width: 2
        },
    ];

    const headers = [
        "G. SETOR", "REPRESENTANTE", "ACERTO", "QTD", "TIPO"
    ]
    const csvReport = {
        data: list.map(row => Object.values(row)),
        headers: headers,
        filename: 'Acompanhamento.csv'
    };

    return (
        <>
            <AliancaMenu />
            <Container className="app-margin">
                {loading ? <Segment><CustomLoader /></Segment> :
                    <Grid columns="equal">
                        <Grid.Row>
                            <Grid.Column>
                                <Header size="huge" content={`Acompanhamento de kits`} icon="tachometer alternate" />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Form>
                                    <Form.Group widths="equal">
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="regionalId"
                                                noResultsMessage="Nenhum registro encontrado."
                                                placeholder="Selecione"
                                                label="G. Regional"
                                                onChange={onRegionalManagerChange}
                                                options={regionalManagers.map(regionalManager => { return { key: regionalManager.id, value: regionalManager.id, text: regionalManager.nome } })}
                                                value={state.regionalId}
                                                clearable
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="sectorId"
                                                noResultsMessage="Nenhum registro encontrado."
                                                placeholder="Selecione"
                                                label="G. Setor"
                                                onChange={onSectorManagerChange}
                                                options={sectorManagers.map(sectorManager => { return { key: sectorManager.id, value: sectorManager.id, text: sectorManager.nome } })}
                                                value={state.sectorId}
                                                clearable
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="agentId"
                                                noResultsMessage="Nenhum registro encontrado."
                                                placeholder="Selecione"
                                                label="Representante"
                                                onChange={onDropdownChange}
                                                options={agents.map(agent => { return { key: agent.id, value: agent.id, text: agent.nome } })}
                                                value={state.agentId}
                                                clearable
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Form>
                                    <Form.Group widths="equal">
                                        <Form.Field width="1">
                                            <label>Mensal</label>
                                            <Checkbox
                                                toggle
                                                onChange={onChangeMensal}
                                                checked={state.mensal}
                                            />
                                        </Form.Field>
                                        <Form.Field width="3">
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="year"
                                                placeholder="Selecione o ano"
                                                label="Ano"
                                                options={optionsYear}
                                                value={state.year}
                                                onChange={onDropdownChange}
                                                required
                                            />
                                        </Form.Field>
                                        {state.mensal === true &&
                                            <Form.Field>
                                                <Form.Dropdown
                                                    fluid
                                                    selection
                                                    search
                                                    scrolling
                                                    name="month"
                                                    placeholder="Selecione o mês"
                                                    label="Mês"
                                                    options={optionsMonth}
                                                    value={state.month}
                                                    onChange={onDropdownChange}
                                                    required
                                                />
                                            </Form.Field>
                                        }
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="tipo"
                                                placeholder="Tipo"
                                                label="Tipo"
                                                options={optionsType}
                                                value={state.tipo}
                                                onChange={onDropdownChange}
                                                required
                                                clearable
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="statusKit"
                                                placeholder="Status"
                                                label="Status"
                                                options={optionsState}
                                                value={state.statusKit}
                                                onChange={onDropdownChange}
                                                required
                                                clearable
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="liberacao"
                                                placeholder="Liberação"
                                                label="Liberação"
                                                options={optionsLiberation}
                                                value={state.liberacao}
                                                onChange={onDropdownChange}
                                                required
                                                clearable
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="prorrogado"
                                                placeholder="Prorrogado"
                                                label="Prorrogado"
                                                options={optionsProrrogado}
                                                value={state.prorrogado}
                                                onChange={onDropdownChange}
                                                required
                                                clearable
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width="15">
                                <Button
                                    disabled={setDisabled()}
                                    fluid
                                    icon="search"
                                    color="pink"
                                    content="Atualizar"
                                    onClick={load}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <CSVLink
                                    separator={";"}
                                    {...csvReport}
                                >
                                    <Button
                                        fluid
                                        color="green"
                                        icon
                                        disabled={list.length > 0 ? false : true}
                                    >
                                        <Icon name="download" />
                                    </Button>
                                </CSVLink>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>

                                {state.tipo === "0,1" && list.length > 0 &&
                                    <><Segment raised color="black">
                                        <Statistic.Group widths="3">
                                            <Statistic color="black">
                                                <Statistic.Value>{total}</Statistic.Value>
                                                <Statistic.Label content="Total"></Statistic.Label>
                                            </Statistic>
                                            <Statistic color="pink">
                                                <Statistic.Value>{totalNovo}</Statistic.Value>
                                                <Statistic.Label content="Total Novo"></Statistic.Label>
                                            </Statistic>
                                            <Statistic color="purple">
                                                <Statistic.Value>{totalAcerto}</Statistic.Value>
                                                <Statistic.Label content="TotalAcerto"></Statistic.Label>
                                            </Statistic>
                                        </Statistic.Group>
                                    </Segment>
                                    </>
                                }
                                {state.tipo === "0" && list.length > 0 &&
                                    <>
                                        <Segment raised color="black">
                                            <Statistic.Group widths="1">
                                                <Statistic color="pink">
                                                    <Statistic.Value>{totalNovo}</Statistic.Value>
                                                    <Statistic.Label content="Total Novo"></Statistic.Label>
                                                </Statistic>
                                            </Statistic.Group>
                                        </Segment>
                                    </>
                                }
                                {state.tipo === "1" && list.length > 0 &&
                                    <>
                                        <Segment raised color="black">
                                            <Statistic.Group widths="1">
                                                <Statistic color="purple">
                                                    <Statistic.Value>{totalAcerto}</Statistic.Value>
                                                    <Statistic.Label content="Total Acerto"></Statistic.Label>
                                                </Statistic>
                                            </Statistic.Group>
                                        </Segment>
                                    </>
                                }
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Column>
                            <Grid.Row>
                                <TableApp
                                    render={tableRender}
                                    list={list}
                                    loading={loading}
                                />
                            </Grid.Row>
                        </Grid.Column>
                    </Grid>
                }
            </Container>
            <Footer />
        </>
    );
};

export default AgentOpened;
